import { lazy, ComponentType } from 'react';
import {
  CALLBACK,
  COMPLETE_ORDER,
  HOME,
  LOGIN,
  NUTRITION,
  ORDER,
  PRIVACY_POLICY,
  PRODUCT,
  TERMS_CONDITIONS,
} from '../constants';
import ComingSoon from '@/pages/ComingSoon/ComingSoon';
import Home from '@/pages/Home/Home';
import Nutrition from '@/pages/Nutrition/Nutrition';
import Product from '@/pages/Product/Product';

const isPreRelease = import.meta.env.VITE_ENVIRONMENT == 'pre_release';

type BRoute = { name: string; path: string; component: ComponentType<any> };

// 1. Define the loading functions separately
export const loadSignin = () =>
  import('../pages/Login/Login').then((m) => ({
    default: m.default,
  }));
export const loadOrderPage = () =>
  import('../pages/Order/Order').then((m) => ({
    default: m.Order,
  }));
export const loadOrderComplete = () =>
  import('../pages/orderComplete/orderComplete').then((m) => ({
    default: m.OrderComplete,
  }));
export const loadPrivacyPolicy = () =>
  import('../pages/privacypolicy/privacypolicy').then((m) => ({
    default: m.PrivacyPolicy,
  }));
export const loadTermsAndConditions = () =>
  import('../pages/TermsAndConditions/TermsAndConditions').then((m) => ({
    default: m.TermsAndConditions,
  }));

// 2. Pass those functions into lazy()
const Login = lazy(loadSignin);
const Order = lazy(loadOrderPage);
const OrderComplete = lazy(loadOrderComplete);
const PrivacyPolicy = lazy(loadPrivacyPolicy);
const TermsAndConditions = lazy(loadTermsAndConditions);

const bRoutes: BRoute[] = isPreRelease
  ? [
      {
        name: 'Privacy Policy',
        path: PRIVACY_POLICY,
        component: PrivacyPolicy,
      },
      {
        name: 'Terms & Conditions',
        path: TERMS_CONDITIONS,
        component: TermsAndConditions,
      },
    ]
  : [
      { name: 'Order', path: ORDER, component: Order },
      {
        name: 'Login',
        path: LOGIN,
        component: Login,
      },
      {
        name: 'Order Complete',
        path: COMPLETE_ORDER,
        component: OrderComplete,
      },
      {
        name: 'Privacy Policy',
        path: PRIVACY_POLICY,
        component: PrivacyPolicy,
      },
      {
        name: 'Terms & Conditions',
        path: TERMS_CONDITIONS,
        component: TermsAndConditions,
      },
      {
        name: 'Nutrition',
        path: NUTRITION,
        component: Nutrition,
      },
      {
        name: 'Product',
        path: PRODUCT,
        component: Product,
      },
    ];

export default bRoutes;
